/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProviderDirectoryContact } from './ProviderDirectoryContact';
import {
    ProviderDirectoryContactFromJSON,
    ProviderDirectoryContactFromJSONTyped,
    ProviderDirectoryContactToJSON,
} from './ProviderDirectoryContact';

/**
 * 
 * @export
 * @interface ListDirectoryContacts200Response
 */
export interface ListDirectoryContacts200Response {
    /**
     * 
     * @type {Array<ProviderDirectoryContact>}
     * @memberof ListDirectoryContacts200Response
     */
    data?: Array<ProviderDirectoryContact>;
}

/**
 * Check if a given object implements the ListDirectoryContacts200Response interface.
 */
export function instanceOfListDirectoryContacts200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListDirectoryContacts200ResponseFromJSON(json: any): ListDirectoryContacts200Response {
    return ListDirectoryContacts200ResponseFromJSONTyped(json, false);
}

export function ListDirectoryContacts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDirectoryContacts200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ProviderDirectoryContactFromJSON)),
    };
}

export function ListDirectoryContacts200ResponseToJSON(value?: ListDirectoryContacts200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ProviderDirectoryContactToJSON)),
    };
}

